// show splash
export function showSplash({ splash, title, description } = {}) {
    let type;
    switch (splash) {
        case 'load':
            type = 'SPLASH_SHOW_LOADING';
            break;
        case 'ball':
            type = 'SPLASH_SHOW_BALL';
            break;
        case 'save':
            type = 'SPLASH_SHOW_SAVING';
            break;
        case 'done':
            type = 'SPLASH_SHOW_DONE';
            break;
        default:
            type = 'SPLASH_SHOW';
            break;
    }

    return (dispatch) => {
        dispatch({
            type,
            title,
            description,
        });
    };
}

// hide splash
export function hideSplash() {
    return (dispatch) => {
        dispatch({
            type: 'SPLASH_HIDE',
        });
    };
}
